module.exports = __webpack_public_path__ + "img/Cumulative impact assessment-Monitoring plan.d45f956b.svg";